// Libraries
import I18n from 'i18next'
import moment from 'moment-timezone'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Link } from '@react-navigation/web'
import React, { Component, Fragment } from 'react'
import { message, Tabs, Modal, Statistic, Icon, Button, Select } from 'antd'
import {
  get,
  defaultTo,
  toNumber,
  includes,
  map,
  forEach,
  isNil,
  toSafeInteger,
  clamp
} from 'lodash'

// Ressources
import { actions as scenarioActions } from 'Resources/ScenarioResource'
import { actions as eventActions } from 'Resources/EventResource'
import { actions as commentActions } from 'Resources/CommentResource'
import WebSocketActions from 'WebSocket/Redux'

// Tabs
import { Information, Events } from './Tabs'

// Common components
import { Gauge, ManageModal } from 'Components'

// Styles
import './ScenarioScreen.less'

const { TabPane } = Tabs
const { confirm } = Modal
const { Countdown } = Statistic
const { Option } = Select

class ScenarioScreen extends Component {
  static propTypes = {
    // Actions de l'API
    actions: PropTypes.object,
    muteScenario: PropTypes.func,
    listenScenario: PropTypes.func,

    // DonnÃ©es de la vue
    scenario: PropTypes.object,
    event: PropTypes.object,

    // Navigation
    navigation: PropTypes.shape({
      navigate: PropTypes.func.isRequired,
      getParam: PropTypes.func.isRequired
    }),

    // TÃ©moins d'activitÃ© API
    isGathering: PropTypes.bool,
    isUpdating: PropTypes.bool,

    // Structure de la manageModal
    manageModal: PropTypes.object
  }

  static defaultProps = {
    // DonnÃ©es de la vue
    scenario: {},
    event: {},

    // TÃ©moins d'activitÃ© API
    isGathering: false,
    isUpdating: false,

    // Structure de la manageModal
    manageModal: {
      title: {
        update: 'pages.scenario.modal.event.update.single.title',
        create: 'pages.scenario.modal.event.create.single.title'
      },
      okText: {
        update: 'pages.scenario.modal.event.update.single.okText',
        create: 'pages.scenario.modal.event.create.single.okText'
      },
      rows: {
        // Ãtape paramÃ¨tres
        impactant: {
          title: 'pages.scenario.modal.event.rows.impactant.title',
          dataIndex: 'impactant',
          key: 'impactant',
          formField: {
            type: 'radios',
            initialValue: true,
            label: 'pages.scenario.modal.event.rows.impactant.title',
            required:
              'pages.scenario.modal.event.rows.impactant.requiredMessage',
            placeholder: 'pages.scenario.modal.event.rows.impactant.placeholder'
          }
        },
        startDate: {
          title: 'pages.scenario.modal.event.rows.startDate.title',
          dataIndex: 'startDate',
          key: 'startDate',
          formField: {
            visibility: {
              fieldsValues: {
                impactant: true
              }
            },
            type: 'datetime',
            initialValue: moment(),
            label: 'pages.scenario.modal.event.rows.startDate.title',
            required:
              'pages.scenario.modal.event.rows.startDate.requiredMessage',
            placeholder:
              'pages.scenario.modal.event.rows.startDate.placeholder',
            format: date => (moment(date).isValid() ? moment(date) : null)
          }
        },
        endDate: {
          title: 'pages.scenario.modal.event.rows.endDate.title',
          dataIndex: 'endDate',
          key: 'endDate',
          formField: {
            visibility: {
              fieldsValues: {
                impactant: true
              }
            },
            type: 'datetime',
            label: 'pages.scenario.modal.event.rows.endDate.title',
            placeholder: 'pages.scenario.modal.event.rows.endDate.placeholder',
            format: date => (moment(date).isValid() ? moment(date) : null)
          }
        },
        operation: {
          title: 'pages.scenario.modal.event.rows.operation.title',
          dataIndex: 'operation',
          key: 'operation',
          formField: {
            visibility: {
              fieldsValues: {
                impactant: true
              }
            },
            type: 'radios',
            label: 'pages.scenario.modal.event.rows.operation.title',
            required:
              'pages.scenario.modal.event.rows.operation.requiredMessage',
            placeholder: 'pages.scenario.modal.event.rows.operation.placeholder'
          }
        },
        operationProperty: {
          title: 'pages.scenario.modal.event.rows.operationProperty.title',
          dataIndex: 'operationProperty',
          key: 'operationProperty',
          formField: {
            visibility: {
              fieldsValues: {
                impactant: true
              }
            },
            type: 'radios',
            label: 'pages.scenario.modal.event.rows.operationProperty.title',
            required:
              'pages.scenario.modal.event.rows.operationProperty.requiredMessage',
            placeholder:
              'pages.scenario.modal.event.rows.operationProperty.placeholder'
          }
        },
        volumeValue: {
          title: 'pages.scenario.modal.event.rows.value.title',
          dataIndex: 'volumeValue',
          key: 'volumeValue',
          formField: {
            visibility: {
              fieldsValues: {
                operationProperty: 'VOLUME',
                impactant: true
              }
            },
            label: 'pages.scenario.modal.event.rows.value.title',
            required: 'pages.scenario.modal.event.rows.value.requiredMessage',
            placeholder: 'pages.scenario.modal.event.rows.value.placeholder',
            pattern: {
              pattern: '^(?=.)(([0-9]*)([\\.,]([0-9]+))?)$',
              transform: value => String(value),
              message: 'pages.scenario.modal.event.rows.value.patternMessage'
            },
            addonAfter: 'mÂ³',
            format: volumeValue =>
              !isNil(volumeValue) ? toNumber(volumeValue) : undefined
          }
        },
        flowValue: {
          title: 'pages.scenario.modal.event.rows.value.title',
          dataIndex: 'flowValue',
          key: 'flowValue',
          formField: {
            visibility: {
              fieldsValues: {
                operationProperty: 'FLOW',
                impactant: true
              }
            },
            label: 'pages.scenario.modal.event.rows.value.title',
            required: 'pages.scenario.modal.event.rows.value.requiredMessage',
            placeholder: 'pages.scenario.modal.event.rows.value.placeholder',
            pattern: {
              pattern: '^(?=.)(([0-9]*)([\\.,]([0-9]+))?)$',
              transform: value => String(value),
              message: 'pages.scenario.modal.event.rows.value.patternMessage'
            },
            addonAfter: 'mÂ³/h',
            format: flowValue =>
              !isNil(flowValue) ? toNumber(flowValue) : undefined
          }
        },
        target: {
          title: 'pages.scenario.modal.event.rows.target.title',
          dataIndex: 'target',
          key: 'target',
          formField: {
            visibility: {
              fieldsValues: {
                impactant: true
              }
            },
            type: 'radios',
            label: 'pages.scenario.modal.event.rows.target.title',
            required: 'pages.scenario.modal.event.rows.target.requiredMessage',
            placeholder: 'pages.scenario.modal.event.rows.target.placeholder'
          }
        },
        basinElement: {
          title: 'pages.scenario.modal.event.rows.element.title',
          dataIndex: 'basinElement',
          key: 'basinElement',
          formField: {
            visibility: {
              fieldsValues: {
                target: 'BASIN',
                impactant: true
              }
            },
            type: 'radios',
            label: 'pages.scenario.modal.event.rows.element.title',
            required: 'pages.scenario.modal.event.rows.element.requiredMessage',
            placeholder: 'pages.scenario.modal.event.rows.element.placeholder'
          }
        },
        tankElement: {
          title: 'pages.scenario.modal.event.rows.element.title',
          dataIndex: 'tankElement',
          key: 'tankElement',
          formField: {
            visibility: {
              fieldsValues: {
                target: 'TANK',
                impactant: true
              }
            },
            type: 'radios',
            label: 'pages.scenario.modal.event.rows.element.title',
            required: 'pages.scenario.modal.event.rows.element.requiredMessage',
            placeholder: 'pages.scenario.modal.event.rows.element.placeholder'
          }
        },
        affectsTank: {
          title: 'pages.scenario.modal.event.rows.affectsTank.title',
          dataIndex: 'affectsTank',
          key: 'affectsTank',
          formField: {
            visibility: {
              fieldsValues: {
                impactant: true,
                basinElement: ['WATER', 'MIX', undefined],
                tankElement: ['WATER', 'EMULSIFIER', undefined]
              }
            },
            type: 'radios',
            label: 'pages.scenario.modal.event.rows.affectsTank.title',
            required:
              'pages.scenario.modal.event.rows.affectsTank.requiredMessage',
            placeholder:
              'pages.scenario.modal.event.rows.affectsTank.placeholder'
          }
        },
        affectsBasin: {
          title: 'pages.scenario.modal.event.rows.affectsBasin.title',
          dataIndex: 'affectsBasin',
          key: 'affectsBasin',
          formField: {
            visibility: {
              fieldsValues: {
                operationProperty: 'FLOW',
                impactant: true
              }
            },
            type: 'radios',
            label: 'pages.scenario.modal.event.rows.affectsBasin.title',
            required:
              'pages.scenario.modal.event.rows.affectsBasin.requiredMessage',
            placeholder:
              'pages.scenario.modal.event.rows.affectsBasin.placeholder'
          }
        },
        basinValue: {
          title: 'pages.scenario.modal.event.rows.basinValue.title',
          dataIndex: 'basinValue',
          key: 'basinValue',
          formField: {
            visibility: {
              fieldsValues: {
                operationProperty: 'FLOW',
                target: 'BASIN',
                affectsBasin: true,
                impactant: true
              }
            },
            label: 'pages.scenario.modal.event.rows.basinValue.title',
            required:
              'pages.scenario.modal.event.rows.basinValue.requiredMessage',
            placeholder:
              'pages.scenario.modal.event.rows.basinValue.placeholder',
            pattern: {
              pattern: '^(?=.)(([0-9]*)([\\.,]([0-9]+))?)$',
              transform: value => String(value),
              message:
                'pages.scenario.modal.event.rows.basinValue.patternMessage'
            },
            addonAfter: 'mÂ³/h',
            format: applicationRate =>
              !isNil(applicationRate) ? toNumber(applicationRate) : undefined
          }
        },
        comment: {
          title: 'pages.scenario.modal.event.rows.comment.title',
          dataIndex: 'comment',
          key: 'comment',
          formField: {
            required: {
              fieldsValues: {
                impactant: false
              },
              message: 'pages.scenario.modal.event.rows.comment.requiredMessage'
            },
            type: 'textarea',
            label: 'pages.scenario.modal.event.rows.comment.title',
            placeholder: 'pages.scenario.modal.event.rows.comment.placeholder'
          }
        }
      }
    }
  }

  constructor(props) {
    super(props)

    this.state = {}
  }

  componentDidMount = () => {
    // RÃ©cupÃ©ration des donnÃ©es de la vue
    this.getScenarioData()
  }

  componentWillUnmount = () => {
    // Ferme la websocket permettant d'Ã©couter un scÃ©nario
    this.closeWebSocket()
  }

  /**
   * Ouvre la websocket permettant d'Ã©couter un scÃ©nario
   */
  openWebSocket = () => {
    const { navigation } = this.props
    const id = navigation.getParam('id')

    this.props.listenScenario(id)
  }

  /**
   * Ferme la websocket permettant d'Ã©couter un scÃ©nario
   */
  closeWebSocket = () => {
    const { navigation } = this.props
    const id = navigation.getParam('id')

    this.props.muteScenario(id)
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es de la vue
   */
  getScenarioData = () => {
    const { navigation } = this.props
    const id = navigation.getParam('id')
    const status = navigation.getParam('status')

    this.props.actions
      .getScenario(id)
      .then(({ body: scenario }) => {
        // Si la navigation est mauvaise pour le status du scÃ©nario
        // Effectuer une redirection
        navigation.setParams({
          status: isNil(get(scenario, 'endDate')) ? 'running' : 'done'
        })

        // Ouvre la websocket permettant d'Ã©couter un scÃ©nario
        this.openWebSocket()

        // RÃ©cupÃ©ration des donnÃ©es calculÃ©es de la vue
        this.getScenarioComputedData(scenario)
      })
      .catch(({ statusCode }) => {
        // Si le scÃ©nario n'existe pas, redirection vers la liste globale
        if (statusCode === 404) {
          message.error(I18n.t('api.errors.scenario.not-found'))
          navigation.navigate('Scenarios', {
            status
          })
        } else {
          message.error(I18n.t('api.errors.scenario.get'))
        }
      })
  }

  /**
   * RÃ©cupÃ©ration des donnÃ©es calculÃ©es de la vue
   */
  getScenarioComputedData = scenario => {
    this.props.actions.getComputedScenario(scenario).catch(({ statusCode }) => {
      message.error(I18n.t('api.errors.scenario.get'))
    })
  }

  /**
   * ClÃ´ture d'une ligne du tableau
   */
  closeScenario = () => {
    const { navigation } = this.props
    const id = navigation.getParam('id')

    this.props.actions
      .closeScenario(id)
      .then(() => {
        this.handleCloseModal()
        message.success(I18n.t('api.success.scenario.close'))
        this.props.navigation.navigate('Scenarios', {
          status: 'done'
        })
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scenario.close'))
      })
  }

  /**
   * Actions groupÃ©e:
   * Demande de clÃ´ture de plusieurs lignes du tableau
   */
  askCloseScenario = () => {
    confirm({
      title: I18n.t('pages.scenarios.modal.close.single.title'),
      content: I18n.t('pages.scenarios.modal.close.single.content'),
      okText: I18n.t('pages.scenarios.modal.close.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scenarios.modal.close.single.cancelText'),
      onOk: this.closeScenario,
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Archivage d'une ligne du tableau
   */
  archiveScenario = () => {
    const { navigation } = this.props
    const id = navigation.getParam('id')

    this.props.actions
      .archiveScenario(id)
      .then(() => {
        message.success(I18n.t('api.success.scenario.archive'))
        this.props.navigation.navigate('Scenarios', {
          status: 'done'
        })
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scenario.archive'))
      })
  }

  /**
   * Demande d'archivage d'un scenario
   */
  askArchiveScenario = () => {
    confirm({
      title: I18n.t('pages.scenarios.modal.archive.single.title'),
      content: I18n.t('pages.scenarios.modal.archive.single.content'),
      okText: I18n.t('pages.scenarios.modal.archive.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scenarios.modal.archive.single.cancelText'),
      onOk: this.archiveScenario,
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Suppression d'une ligne du tableau
   */
  deleteScenario = () => {
    const { scenario } = this.props

    this.props.actions
      .deleteScenario(scenario)
      .then(() => {
        message.success(I18n.t('api.success.scenario.delete'))
        this.props.navigation.navigate('Scenarios')
      })
      .catch(() => {
        message.error(I18n.t('api.errors.scenario.delete'))
      })
  }

  /**
   * Demande de suppression d'un scenario
   */
  askDeleteScenario = () => {
    confirm({
      title: I18n.t('pages.scenarios.modal.delete.single.title'),
      content: I18n.t('pages.scenarios.modal.delete.single.content'),
      okText: I18n.t('pages.scenarios.modal.delete.single.okText'),
      okType: 'danger',
      cancelText: I18n.t('pages.scenarios.modal.delete.single.cancelText'),
      onOk: this.deleteScenario,
      maskClosable: true,
      centered: false
    })
  }

  /**
   * Conversion d'une unit de volume temps Ã  une autre
   */
  convertFlowUnit = (value, unit, wantedUnit = 'm3h') => {
    let result = toNumber(value)

    if (wantedUnit === 'm3h') {
      // UnitÃ© source: m3/h
      // Conversion en litre par minute
      if (unit === 'lmin') {
        // Conversion en litre par heure
        result /= 1000
        // Conversion en litre par minute
        result *= 60
      }
    } else if (wantedUnit === 'lmin') {
      // UnitÃ© source: L/min
      // Conversion en mÃ¨tre cube par heure
      if (unit === 'm3h') {
        // Conversion en mÃ¨tre cube par minutes
        result *= 1000
        // Conversion en mÃ¨tre cube par heure
        result /= 60
      }
    }

    return result
  }

  /**
   * Mise Ã  jour d'un Ã©vÃ©nement
   */
  updateEvent = (
    { basinElement, tankElement, impactant, target, ...updatedEvent },
    originalEvent
  ) =>
    new Promise((resolve, reject) => {
      const { navigation } = this.props
      const { selectedFlowFieldsUnit } = this.state

      // Pour chaque champs de flux, conversion de la valeur en m3/h quelque que soit l'unitÃ© choisie
      forEach(selectedFlowFieldsUnit, (unit, field) => {
        updatedEvent[field] = this.convertFlowUnit(updatedEvent[field], unit)
      })

      this.setState({
        selectedFlowFieldsUnit: {}
      })

      // Adaptation du formulaire pour envoi Ã  l'API
      updatedEvent.eventType = impactant ? target : 'COMMENT'
      updatedEvent.startDate = defaultTo(updatedEvent.startDate, moment())
      // todo: rustine +2h
      updatedEvent.startDate.add(2, 'hours')
      
      if (updatedEvent.endDate !== null) {
        updatedEvent.endDate.add(2, 'hours')

      }

      if (updatedEvent.eventType !== 'COMMENT') {
        updatedEvent.element =
          updatedEvent.eventType === 'BASIN' ? basinElement : tankElement
      }

      const promise =
        updatedEvent.eventType === 'COMMENT'
          ? this.props.actions.updateComment
          : this.props.actions.updateEvent

      promise({
        scenario: navigation.getParam('id'),
        id: get(originalEvent, 'id'),
        ...updatedEvent
      })
        .then(response => {
          this.handleCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.scenario.update'))

          // RafraÃ®chissement de la liste des Ã©vÃ©nements du scÃ©nario
          this.getScenarioData()
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.scenario.update'))
        })
    })

  /**
   * CrÃ©ation d'un Ã©vÃ©nement
   */
  createEvent = ({
    basinElement,
    tankElement,
    impactant,
    target,
    ...createdEvent
  }) =>
    new Promise((resolve, reject) => {
      const { navigation } = this.props
      const { selectedFlowFieldsUnit } = this.state

      // Pour chaque champs de flux, conversion de la valeur en m3/h quelque que soit l'unitÃ© choisie
      forEach(selectedFlowFieldsUnit, (unit, field) => {
        createdEvent[field] = this.convertFlowUnit(createdEvent[field], unit)
      })

      this.setState({
        selectedFlowFieldsUnit: {}
      })

      // Adaptation du formulaire pour envoi Ã  l'API
      createdEvent.eventType = impactant ? target : 'COMMENT'
      createdEvent.startDate = defaultTo(createdEvent.startDate, moment())
            // todo: rustine +2h
      createdEvent.startDate.add(2, 'hours')
      
      if (createdEvent.endDate !== null) {
        createdEvent.endDate.add(2, 'hours')

      }


      if (createdEvent.eventType !== 'COMMENT') {
        createdEvent.element =
          createdEvent.eventType === 'BASIN' ? basinElement : tankElement
      }

      const promise =
        createdEvent.eventType === 'COMMENT'
          ? this.props.actions.createComment
          : this.props.actions.createEvent

      promise({
        scenario: navigation.getParam('id'),
        ...createdEvent
      })
        .then(response => {
          this.handleCloseModal()
          resolve(get(response, 'body'), response)
          message.success(I18n.t('api.success.event.create'))

          // RafraÃ®chissement de la liste des Ã©vÃ©nements du scÃ©nario
          this.getScenarioData()
        })
        .catch(error => {
          reject(error)
          message.error(I18n.t('api.errors.event.create'))
        })
    })

  /**
   * Ouverture de la modale de modifications
   */
  openModal = (creating = true) => {
    this.setState({
      openedModal: creating ? 'createEvent' : 'updateEvent',
      selectedFlowFieldsUnit: {}
    })
  }

  /**
   * Fermeture de toutes les modales
   */
  handleCloseModal = () => {
    const { openedModal } = this.state

    if (openedModal === 'updateEvent') {
      this.setState({ openedModal: 'transition' }, () => {
        setTimeout(
          this.setState({ openedModal: null, selectedFlowFieldsUnit: {} }),
          200
        )
      })
    } else {
      this.setState({ openedModal: null, selectedFlowFieldsUnit: {} })
    }
  }

  /**
   * Callback:
   * CrÃ©ation d'une ligne de tableau rÃ©ussie
   */
  handleEventCreated = () => {
    this.handleCloseModal()
  }

  /**
   * Permet de limiter les pourcentages entre 0% et 100%
   */
  clampPercent = percent => clamp(defaultTo(percent, 0), 0, 100)

  /**
   * Permet de calculer un pourcentage Ã  partir d'une valeur et de son maximum
   */
  percent = (min, max) =>
    defaultTo((defaultTo(min, 0) / defaultTo(max, 0)) * 100, 0)

  /**
   * Rendu des gauges de remplissage des rÃ©servoirs et de la cuvette
   */
  renderGauges = () => {
    const { scenario } = this.props

    // RÃ©cupÃ©ration du status du scÃ©nario
    const status = isNil(get(scenario, 'endDate')) ? 'running' : 'done'

    const basinSource = !isNil(get(scenario, 'basin'))
      ? get(scenario, 'basin')
      : get(scenario, 'silo.basin')

    // Cuvette
    const basin = {
      id: defaultTo(get(basinSource, 'id'), 0),
      name: get(basinSource, 'name'),
      percent: this.clampPercent(
        this.percent(
          get(basinSource, 'remainingVolume'),
          get(basinSource, 'overflowVolume')
        )
      ),
      remainingVolume: defaultTo(get(basinSource, 'remainingVolume'), 0),
      remainingTime: defaultTo(get(basinSource, 'remainingTime'), 0)
    }

    // RÃ©servoir d'eau
    const waterTank = {
      id: defaultTo(get(scenario, 'waterTank.id'), 0),
      name: get(scenario, 'waterTank.name'),
      percent: this.clampPercent(
        this.percent(
          get(scenario, 'waterTank.remainingVolume'),
          get(scenario, 'waterTank.volume')
        )
      ),
      remainingVolume: defaultTo(get(scenario, 'waterTank.remainingVolume'), 0),
      consumedVolume: defaultTo(get(scenario, 'waterTank.consumedVolume'), 0),
      remainingTime: defaultTo(get(scenario, 'waterTank.remainingTime'), 0)
    }

    // RÃ©servoir d'Ã©mulseur
    const emulsifierTank = {
      id: defaultTo(get(scenario, 'emulsifierTank.id'), 0),
      name: get(scenario, 'emulsifierTank.name'),
      percent: this.clampPercent(
        this.percent(
          get(scenario, 'emulsifierTank.remainingVolume'),
          get(scenario, 'emulsifierTank.volume')
        )
      ),
      remainingVolume: defaultTo(
        get(scenario, 'emulsifierTank.remainingVolume'),
        0
      ),
      consumedVolume: defaultTo(
        get(scenario, 'emulsifierTank.consumedVolume'),
        0
      ),
      remainingTime: defaultTo(get(scenario, 'emulsifierTank.remainingTime'), 0)
    }

    return (
      <div className='scenario-gauges'>
        {/* Gauge de dÃ©bordement de la cuvette */}
        <div className='scenario-gauges-item'>
          <Gauge
            startColor='#dce35b'
            endColor='#45b649'
            value={basin.percent}
            radius={60}
          />
          <div className='scenario-gauges-item-details'>
            <h3 className='scenario-gauges-item-title'>
              {I18n.t('pages.scenario.basin.title')}
            </h3>
            <Link
              routeName='Basins'
              params={{ id: basin.id }}
              className='scenario-gauges-item-name'
            >
              {basin.name}
            </Link>

            <div className='scenario-gauges-item-statistics'>
              {/* Volume actuel */}
              <Statistic
                prefix={
                  status === 'running' &&
                  basin.remainingTime > 0 && <Icon type='arrow-up' />
                }
                title={I18n.t('pages.scenario.basin.remainingVolume')}
                value={toSafeInteger(basin.remainingVolume).toLocaleString()}
                groupSeparator=' '
                decimalSeparator=','
                suffix='mÂ³'
              />

              {/* Temps restant */}
              {status === 'running' && basin.remainingTime > 0 && (
                <Countdown
                  title={I18n.t('pages.scenario.basin.remainingTime')}
                  value={moment().add(basin.remainingTime, 'seconds')}
                  format='HH:mm'
                />
              )}
            </div>
          </div>
        </div>

        {/* Gauge de remplissage du reservoir d'eau */}
        <div className='scenario-gauges-item'>
          <Gauge
            startColor='#6f86d6'
            endColor='#48c6ef'
            value={waterTank.percent}
            radius={60}
          />
          <div className='scenario-gauges-item-details'>
            <h3 className='scenario-gauges-item-title'>
              {I18n.t('pages.scenario.waterTank.title')}
            </h3>
            <Link
              routeName='Tanks'
              params={{ id: waterTank.id }}
              className='scenario-gauges-item-name'
            >
              {waterTank.name}
            </Link>

            <div className='scenario-gauges-item-statistics'>
              {/* Volume actuel */}
              <Statistic
                prefix={
                  status === 'running' &&
                  waterTank.remainingVolume > 0 && <Icon type='arrow-down' />
                }
                title={I18n.t('pages.scenario.waterTank.remainingVolume')}
                value={toSafeInteger(
                  waterTank.remainingVolume
                ).toLocaleString()}
                groupSeparator=' '
                decimalSeparator=','
                suffix='mÂ³'
              />

              {/* Volume total consommÃ© */}
              {(status === 'done' || waterTank.remainingVolume === 0) && (
                <Statistic
                  title={I18n.t('pages.scenario.waterTank.consumedVolume')}
                  value={toSafeInteger(
                    waterTank.consumedVolume
                  ).toLocaleString()}
                  groupSeparator=' '
                  decimalSeparator=','
                  suffix='mÂ³'
                />
              )}

              {/* Temps restant */}
              {status === 'running' && waterTank.remainingVolume > 0 && (
                <Countdown
                  title={I18n.t('pages.scenario.waterTank.remainingTime')}
                  value={moment().add(waterTank.remainingTime, 'seconds')}
                  format='HH:mm'
                />
              )}
            </div>
          </div>
        </div>

        {/* Gauge de remplissage du reservoir d'Ã©mulseur */}
        <div className='scenario-gauges-item'>
          <Gauge
            startColor='#7028e4'
            endColor='#e5b2ca'
            value={emulsifierTank.percent}
            radius={60}
          />
          <div className='scenario-gauges-item-details'>
            <h3 className='scenario-gauges-item-title'>
              {I18n.t('pages.scenario.emulsifierTank.title')}
            </h3>
            <Link
              routeName='Tanks'
              params={{ id: emulsifierTank.id }}
              className='scenario-gauges-item-name'
            >
              {emulsifierTank.name}
            </Link>

            <div className='scenario-gauges-item-statistics'>
              {/* Volume actuel */}
              <Statistic
                prefix={
                  status === 'running' &&
                  emulsifierTank.remainingVolume > 0 && (
                    <Icon type='arrow-down' />
                  )
                }
                title={I18n.t('pages.scenario.emulsifierTank.remainingVolume')}
                value={toSafeInteger(
                  emulsifierTank.remainingVolume
                ).toLocaleString()}
                groupSeparator=' '
                decimalSeparator=','
                suffix='mÂ³'
              />

              {/* Volume total consommÃ© */}
              {(status === 'done' || emulsifierTank.remainingVolume === 0) && (
                <Statistic
                  title={I18n.t('pages.scenario.emulsifierTank.consumedVolume')}
                  value={toSafeInteger(
                    emulsifierTank.consumedVolume
                  ).toLocaleString()}
                  groupSeparator=' '
                  decimalSeparator=','
                  suffix='mÂ³'
                />
              )}

              {/* Temps restant */}
              {status === 'running' && emulsifierTank.remainingVolume > 0 && (
                <Countdown
                  title={I18n.t('pages.scenario.emulsifierTank.remainingTime')}
                  value={moment().add(emulsifierTank.remainingTime, 'seconds')}
                  format='HH:mm'
                />
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }

  /**
   * Rendu des boutons
   */
  renderButtons = () => {
    const { scenario, navigation } = this.props
    const status = defaultTo(
      get(scenario, 'status'),
      navigation.getParam('status')
    )

    return status === 'done' ? (
      <Fragment>
        <Button type='danger' icon='stop' onClick={this.askDeleteScenario}>
          {I18n.t('pages.scenario.buttons.delete')}
        </Button>
      </Fragment>
    ) : (
      <Fragment>
        <Button type='primary' icon='plus' onClick={this.openModal}>
          {I18n.t('pages.scenario.buttons.create')}
        </Button>
        <Button
          type='danger'
          icon='issues-close'
          onClick={this.askCloseScenario}
        >
          {I18n.t('pages.scenario.buttons.close')}
        </Button>
      </Fragment>
    )
  }

  /**
   * Rendu du sÃ©lecteur d'unitÃ© de temps volume
   */
  renderSelectFlowUnit = input => {
    const onChange = (input, unit) => {
      // UnitÃ©s choisies pour chaque input
      this.setState(({ selectedFlowFieldsUnit = {} }) => {
        selectedFlowFieldsUnit[input] = defaultTo(unit, 'm3h')
        return { selectedFlowFieldsUnit }
      })
    }

    // SÃ©lecteur d'unitÃ©
    return (
      <Select
        value={defaultTo(
          get(this.state, `selectedFlowFieldsUnit[${input}]`),
          'm3h'
        )}
        defaultValue={defaultTo(
          get(this.state, `selectedFlowFieldsUnit[${input}]`),
          'm3h'
        )}
        onChange={unit => onChange(input, unit)}
        style={{ width: 80 }}
      >
        {map(['m3h', 'lmin'], unit => (
          <Option key={unit} value={unit}>
            {I18n.t(`common.units.${unit}`)}
          </Option>
        ))}
      </Select>
    )
  }

  render() {
    const {
      scenario,
      event,
      manageModal,
      navigation,
      isGathering,
      isUpdating
    } = this.props
    const { openedModal } = this.state

    // Gestion du loader
    const loading = isGathering || isUpdating

    // GESTION DE LA MODALE DE GESTION

    // Ajout des options pour le choix d'une opÃ©ration
    manageModal.rows.operation.formField.options = map(
      ['WITHDRAWAL', 'ADDITION'],
      operation => ({
        label: I18n.t(`pages.scenario.modal.event.rows.operation.${operation}`),
        value: operation
      })
    )

    // Ajout des options pour le choix d'une cible
    manageModal.rows.target.formField.options = map(
      ['BASIN', 'TANK'],
      target => ({
        label: I18n.t(`pages.scenario.modal.event.rows.target.${target}`),
        value: target
      })
    )

    // Ajout des options pour le choix d'une propriÃ©tÃ©
    manageModal.rows.operationProperty.formField.options = map(
      ['VOLUME', 'FLOW'],
      operationProperty => ({
        label: I18n.t(
          `pages.scenario.modal.event.rows.operationProperty.${operationProperty}`
        ),
        value: operationProperty
      })
    )

    // Ajout des options pour le choix d'un Ã©lÃ©ment de cuvette
    manageModal.rows.basinElement.formField.options = map(
      ['WATER', 'MIX', 'OTHER'],
      element => ({
        label: I18n.t(`pages.scenario.modal.event.rows.element.${element}`),
        value: element
      })
    )

    // Ajout des options pour le choix d'un Ã©lÃ©ment de rÃ©servoir
    manageModal.rows.tankElement.formField.options = map(
      ['WATER', 'EMULSIFIER', 'OTHER'],
      element => ({
        label: I18n.t(`pages.scenario.modal.event.rows.element.${element}`),
        value: element
      })
    )

    // Ajout des options pour le choix de l'impact sur la cuvette
    manageModal.rows.affectsBasin.formField.options = map(
      [true, false],
      bool => ({
        label: I18n.t(`pages.scenario.modal.event.rows.affectsBasin.${bool}`),
        value: bool
      })
    )

    // Ajout des options pour le choix de l'impact sur la cuvette
    manageModal.rows.affectsTank.formField.options = map(
      [true, false],
      bool => ({
        label: I18n.t(`pages.scenario.modal.event.rows.affectsTank.${bool}`),
        value: bool
      })
    )

    // Ajout des options pour le choix de l'impact des volumes
    manageModal.rows.impactant.formField.options = map([true, false], bool => ({
      label: I18n.t(`pages.scenario.modal.event.rows.impactant.${bool}`),
      value: bool
    }))

    // Ajout du sÃ©lecteur d'unitÃ© (L/min ou m3/h) aux input de dÃ©bit
    forEach(['flowValue', 'basinValue'], input => {
      manageModal.rows[input].formField.addonAfter = this.renderSelectFlowUnit(
        input
      )
    })

    // Gestion des titres
    const titleInformation = (
      <Fragment>
        <Icon type='profile' />
        <span>{I18n.t('pages.scenario.tabs.information.title')}</span>
      </Fragment>
    )

    const titleEvents = (
      <Fragment>
        <Icon type='history' />
        <span>{I18n.t('pages.scenario.tabs.events.title')}</span>
      </Fragment>
    )

    return (
      <main className='screen scenario'>
        {/* RÃ©sumÃ© d'informations sur le scenario */}
        <header>
          <div className='scenario-header-title-container'>
            {/* Nom du scÃ©nario */}
            <h2 className='scenario-header-title'>
              {defaultTo(
                get(scenario, 'name'),
                I18n.t('pages.scenario.idTitle', {
                  id: navigation.getParam('id')
                })
              )}
            </h2>

            {/* Boutons */}
            <div className='scenario-header-actions buttons'>
              {this.renderButtons()}
            </div>
          </div>

          {/* Ãtat des rÃ©servoirs */}
          {this.renderGauges()}
        </header>

        {/* Tabs */}
        <Tabs defaultActiveKey='information' type='card'>
          {/* Information */}
          <TabPane forceRender tab={titleInformation} key='information'>
            <Information title={titleInformation} loading={loading} />
          </TabPane>
          {/* ÃvÃ©nements */}
          <TabPane forceRender tab={titleEvents} key='events'>
            <Events
              title={titleEvents}
              modal={{
                open: () => this.openModal(false),
                close: this.handleCloseModal
              }}
              getScenarioData={this.getScenarioData}
              loading={loading}
            />
          </TabPane>
        </Tabs>

        {/* Ouverture de la modale de crÃ©ation / modification */}
        <ManageModal
          loading={loading}
          onCancel={this.handleCloseModal}
          onOk={this.handleEventCreated}
          onChange={
            openedModal === 'updateEvent' ? this.updateEvent : this.createEvent
          }
          visible={includes(['createEvent', 'updateEvent'], openedModal)}
          data={
            includes(['transition', 'updateEvent'], openedModal) ? event : null
          }
          {...manageModal}
        />
      </main>
    )
  }
}

const mapStateToProps = state => {
  const defaultProps = get(ScenarioScreen, 'defaultProps', {})

  return {
    event: defaultTo(get(state, 'event.item'), defaultProps.event),
    scenario: defaultTo(get(state, 'scenario.item'), defaultProps.scenario),
    isGathering:
      defaultTo(get(state, 'scenario.isFetching'), defaultProps.isGathering) ||
      defaultTo(
        get(state, 'scenario.isFetchingItem'),
        defaultProps.isGathering
      ),
    isUpdating:
      defaultTo(get(state, 'event.isUpdating'), defaultProps.isUpdating) ||
      defaultTo(get(state, 'scenario.isUpdating'), defaultProps.isUpdating)
  }
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    { ...scenarioActions, ...eventActions, ...commentActions },
    dispatch
  ),
  listenScenario: id =>
    dispatch(
      WebSocketActions.wsConnect(
        'scenario',
        `${process.env.REACT_APP_WS_SERVER_URL}?scenario=${id}`
      )
    ),
  muteScenario: id => dispatch(WebSocketActions.wsDisconnect('scenario'))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScenarioScreen)
